import { ChargePointStatusEnum, type ChargePoint, type Connector } from 'types/swagger';

import { isChargePointOnline } from './chargePoint';

const availableStatuses = [ChargePointStatusEnum.Available, ChargePointStatusEnum.Preparing];

const onlineStatuses = [
  ChargePointStatusEnum.Available,
  ChargePointStatusEnum.Preparing,
  ChargePointStatusEnum.Charging,
  ChargePointStatusEnum.Finishing,
  ChargePointStatusEnum.Reserved,
  ChargePointStatusEnum.SuspendedEV,
  ChargePointStatusEnum.SuspendedEVSE,
];

export const isConnectorLatestStatusAvailable = (connector: Connector) => {
  const connectorStatus = connector?.latest_status_notification?.status;
  if (!connectorStatus) return false;
  return availableStatuses.includes(connectorStatus);
};

export const isConnectorLatestStatusOnline = (connector: Connector) => {
  const connectorStatus = connector?.latest_status_notification?.status;
  if (!connectorStatus) return false;
  return onlineStatuses.includes(connectorStatus);
};

export const isConnectorLatestStatusCharging = (connector: Connector) => {
  const connectorStatus = connector?.latest_status_notification?.status;
  if (!connectorStatus) return false;
  return connectorStatus === ChargePointStatusEnum.Charging;
};

export const isConnectorNotAvailable = (connector: Connector) => {
  return !isConnectorLatestStatusOnline(connector);
};

export const isChargePointNotAvailable = (chargePoint: ChargePoint) => {
  return !isChargePointOnline({ status: chargePoint?.status });
};

export const sortConnectorsByLatestStatus = (connectors: Connector[]) => {
  return connectors.sort((a, b) => {
    const aStatus = a.latest_status_notification?.status;
    const bStatus = b.latest_status_notification?.status;
    const validStatuses = [
      ChargePointStatusEnum.Preparing,
      ChargePointStatusEnum.Charging,
      ChargePointStatusEnum.Available,
      ChargePointStatusEnum.Finishing,
    ];
    if (aStatus && bStatus) {
      if (
        aStatus === ChargePointStatusEnum.Preparing &&
        bStatus !== ChargePointStatusEnum.Preparing
      )
        return -1;
      if (
        aStatus !== ChargePointStatusEnum.Preparing &&
        bStatus === ChargePointStatusEnum.Preparing
      )
        return 1;
      if (
        aStatus === ChargePointStatusEnum.Available &&
        bStatus !== ChargePointStatusEnum.Available &&
        bStatus !== ChargePointStatusEnum.Preparing
      )
        return -1;
      if (
        aStatus !== ChargePointStatusEnum.Available &&
        aStatus !== ChargePointStatusEnum.Preparing &&
        bStatus === ChargePointStatusEnum.Available
      )
        return 1;
      if (
        aStatus === ChargePointStatusEnum.Charging &&
        bStatus !== ChargePointStatusEnum.Charging &&
        bStatus !== ChargePointStatusEnum.Preparing &&
        bStatus !== ChargePointStatusEnum.Available
      )
        return -1;
      if (
        aStatus !== ChargePointStatusEnum.Charging &&
        aStatus !== ChargePointStatusEnum.Preparing &&
        aStatus !== ChargePointStatusEnum.Available &&
        bStatus === ChargePointStatusEnum.Charging
      )
        return 1;
      if (
        aStatus === ChargePointStatusEnum.Finishing &&
        bStatus !== ChargePointStatusEnum.Finishing &&
        bStatus !== ChargePointStatusEnum.Preparing &&
        bStatus !== ChargePointStatusEnum.Available &&
        bStatus !== ChargePointStatusEnum.Charging
      )
        return -1;
      if (!validStatuses.includes(aStatus) && validStatuses.includes(bStatus)) return 1;
      if (validStatuses.includes(aStatus) && !validStatuses.includes(bStatus)) return -1;
      if (aStatus === bStatus) return 0;
    }
    return 0;
  });
};
